import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'queue_notifications'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getNotification (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  // aliases for create
  createProofApprovedNotification (proof, signature) {
    return Client.post(`${resource}`, {
      accountId        : proof.accountId,
      typeNotification : 4,
      date             : new Date(),
      userName         : signature,
      projectName      : proof.name,
      orderExternalId  : proof.id
    })
      .then(response => response.data)
  },
  createProofOrderedNotification (proof, order, user, instructions, totalProofs, plantPickup, weight, zone, finalShippingCost) {
    return Client.post(`${resource}`, {
      accountId          : proof.accountId,
      typeNotification   : 5,
      date               : order.createdAt,
      userName           : `${user.firstName} ${user.lastName}`,
      projectName        : proof.name,
      orderExternalId    : order.id,
      info               : instructions,
      carrier            : proof.id,
      typeTrackingNumber : totalProofs,
      typeBook           : plantPickup ? 1 : 0,
      trackingNumber     : weight,
      shippingMethod     : zone ? 1 : 0,
      errorMessage       : finalShippingCost
    })
      .then(response => response.data)
  },
  createPersonalizedOrderSubmitted (accountId, proofId, submitSchoolPersonalizedList = false, orderId = 0, personalizationUserName = '', personalizationUserEmail = '') {
    return Client.post(`${resource}`, {
      accountId,
      typeNotification   : 101,
      info               : proofId,
      typeTrackingNumber : orderId,
      projectName        : personalizationUserName,
      trackingNumber     : personalizationUserEmail,
      typeBook           : submitSchoolPersonalizedList ? 1 : 0
    })
      .then(response => response.data)
  },
  createProofRejected (proof, user, comments) {
    return Client.post(`${resource}`, {
      accountId        : proof.accountId,
      typeNotification : 2,
      date             : new Date(),
      userName         : `${user.firstName} ${user.lastName}`,
      projectName      : proof.name,
      info             : comments,
      orderExternalId  : proof.id
    })
      .then(response => response.data)
  },
  createAccountSoftwareChanged (account, user, originalSoftwareType) {
    return Client.post(`${resource}`, {
      accountId        : account.id,
      typeNotification : 97,
      projectName      : account.typeSoftware,
      userName         : `${user.firstName} ${user.lastName}`,
      info             : originalSoftwareType
    })
      .then(response => response.data)
  },
  createLTLOrderShipped (order) {
    return Client.post(`${resource}`, {
      orderExternalId  : order.externalId,
      accountId        : order.accountId,
      typeNotification : 108,
      projectName      : order.ltlTrackingLink,
      trackingNumber   : order.ltlTrackingNumber,
      carrier          : order.carrier
    })
      .then(response => response.data)
  },
  createLTLOrderDelivered (order, dateDelivered) {
    return Client.post(`${resource}`, {
      orderExternalId  : order.externalId,
      accountId        : order.accountId,
      typeNotification : 109,
      projectName      : order.ltlTrackingLink,
      trackingNumber   : order.ltlTrackingNumber,
      userName         : order.ltlReceivedBy,
      carrier          : order.carrier,
      info             : dateDelivered
    })
      .then(response => response.data)
  },
  createInternallyApproved (proof) {
    return Client.post(`${resource}`, {
      accountId        : proof.accountId,
      typeNotification : 110,
      info             : proof.id
    })
  },
  createNotification (payload) {
    return Client.post(`${resource}`, payload)
  }
}
